import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';

import PageSection from '$landing-page-raika/components/page-section';

// import StoreButton from '$landing-page-raika/components/store-button';
import useStyles from './styles';

import { FontAwesomeIcon } from '$common/fontawesome-pro/react-fontawesome';

const query = graphql`
    query pageFooter {
        site {
            siteMetadata {
                twitter
                facebook
                angel
                linkedin
                productRaikaHealth {
                    appStoreLink
                    googlePlayLink
                }
            }
        }
        logo: file(relativePath: { eq: "logo-colorful-with-shadow.png" }) {
            childImageSharp {
                gatsbyImageData(layout: FIXED, height: 60, quality: 100, placeholder: NONE)
            }
        }
    }
`;

const PageFooter = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isScreenSizeMd = useMediaQuery(theme.breakpoints.up('md'));
    const queryData = useStaticQuery(query);
    return (
        <Box component="div" className={classes.root}>
            <PageSection>
                <Grid container spacing={3} wrap={isScreenSizeMd ? 'nowrap' : 'wrap'} direction="row-reverse">
                    <Grid item xs={12} md={10}>
                        <Grid container wrap="wrap" spacing={2}>
                            <Grid item xs={12} md={4} lg={3}>
                                <Typography
                                    component={Link}
                                    to="/about"
                                    variant="h6"
                                    color="textSecondary"
                                    className={classes.menuItem}
                                >
                                    شرکت
                                </Typography>
                                {isScreenSizeMd && (
                                    <>
                                        <Typography
                                            component={Link}
                                            to="/about"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                        >
                                            درباره
                                        </Typography>
                                        {/* <Typography
                                            component="a"
                                            href="https://ebn-e-sina-research.com.com/blog"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                            rel="noopener noreferrer"
                                        >
                                            وبلاگ
                                        </Typography>
                                        <Typography
                                            component="a"
                                            href="https://learn.ebn-e-sina-research.com.com/events"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                            rel="noopener noreferrer"
                                        >
                                            رویدادها
                                        </Typography>
                                        <Typography
                                            component="a"
                                            href="https://learn.ebn-e-sina-research.com"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                            rel="noopener noreferrer"
                                        >
                                            آموختن Ebn-E-Sina
                                        </Typography>
                                        <Typography
                                            component="a"
                                            href="https://forum.ebn-e-sina-research.com"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                            rel="noopener noreferrer"
                                        >
                                            Ebn-E-Sina انجمن
                                        </Typography>

                                        <Typography
                                            component={Link}
                                            to="/legal#privacy-policy"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                        >
                                            سیاست حفظ حریم خصوصی
                                        </Typography>
                                        <Typography
                                            component={Link}
                                            to="/legal#terms-of-use"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                        >
                                            شرایط استفاده
                                        </Typography>
                                        */}
                                        <Typography
                                            component="a"
                                            href="mailto:info@avicennaresearch.com"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                        >
                                            تماس با ما
                                        </Typography>
                                    </>
                                )}
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <Typography
                                    component={Link}
                                    to="/solutions"
                                    variant="h6"
                                    color="textSecondary"
                                    className={classes.menuItem}
                                >
                                    راه‌حل‌ها
                                </Typography>
                                {isScreenSizeMd && (
                                    <>
                                        <Typography
                                            component={Link}
                                            to="/solutions/research-on-obesity"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                        >
                                            چاقی
                                        </Typography>
                                        <Typography
                                            component={Link}
                                            to="/solutions/research-on-communicable-diseases"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                        >
                                            بیماری های مسری
                                        </Typography>
                                        <Typography
                                            component={Link}
                                            to="/solutions/research-on-environmental-epidemiology"
                                            variant="body2"
                                            color="textSecondary"
                                            className={classes.menuItem}
                                        >
                                            اپیدمیولوژی محیطی
                                        </Typography>
                                    </>
                                )}
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <Typography
                                    component={Link}
                                    to="/features"
                                    variant="h6"
                                    color="textSecondary"
                                    className={classes.menuItem}
                                >
                                    ویژگی‌ها
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <Typography
                                    component={Link}
                                    to="/product"
                                    variant="h6"
                                    color="textSecondary"
                                    className={classes.menuItem}
                                >
                                    محصول
                                </Typography>
                            </Grid>

                            {/* <Grid item xs={12} md={4} lg={2}>
                                <Typography
                                    component="a"
                                    href="/app/dashboard"
                                    target="_blank"
                                    variant="h6"
                                    color="textSecondary"
                                    className={classes.menuItem}
                                >
                                    داشبورد
                                </Typography>
                            </Grid> */}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <GatsbyImage image={getImage(queryData.logo)} className={classes.logo} alt="" />
                        <Grid className={classes.copyRightWrapper} container spacing={1} alignItems="center">
                            <Grid item md={12}>
                                <Typography variant="h6" color="textSecondary" className={classes.rightsReservedText}>
                                    همه حقوق محفوظ است
                                </Typography>
                            </Grid>
                            <Grid item md={12}>
                                <Typography variant="body2" color="textSecondary" className={classes.copyRightText}>
                                    {`© ${new Date().getFullYear()} Ebn-E-Sina Research`}
                                </Typography>
                            </Grid>
                        </Grid>
                        {/* {isScreenSizeMd && (
                            <Grid container>
                                <Grid item xs={6} sm={12} className={classes.appleStoreButtonWrapper}>
                                    <a
                                        href={queryData.site.siteMetadata.productRaikaHealth.appStoreLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <StoreButton type="image" variant="custom" store="apple" />
                                    </a>
                                </Grid>
                                <Grid item xs={6} sm={12}>
                                    <a
                                        href={queryData.site.siteMetadata.productRaikaHealth.googlePlayLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <StoreButton type="image" variant="custom" store="google-play" />
                                    </a>
                                </Grid>
                            </Grid>
                        )} */}
                    </Grid>
                </Grid>
                <Grid container className={classes.bottomWrapper} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <Typography variant="body2" color="textSecondary">
                            استفاده از داده ها برای پیشرفت علم.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} className={classes.bottomSocialWrapper}>
                        <Grid container wrap="nowrap" alignItems="center" justify="flex-end">
                            <Grid item className={classes.bottomSocialLinkWrapper}>
                                <a href={queryData.site.siteMetadata.linkedin} className={classes.bottomSocialLink}>
                                    <FontAwesomeIcon icon={['fab', 'linkedin-in']} size="lg" fixedWidth />
                                </a>
                            </Grid>
                            {/* <Grid item className={classes.bottomSocialLinkWrapper}>
                                <a href={queryData.site.siteMetadata.facebook} className={classes.bottomSocialLink}>
                                    <FontAwesomeIcon icon={['fab', 'facebook-f']} size="lg" fixedWidth />
                                </a>
                            </Grid>
                            <Grid item className={classes.bottomSocialLinkWrapper}>
                                <a href={queryData.site.siteMetadata.twitter} className={classes.bottomSocialLink}>
                                    <FontAwesomeIcon icon={['fab', 'twitter']} size="lg" fixedWidth />
                                </a>
                            </Grid>
                            <Grid item className={classes.bottomSocialLinkWrapper}>
                                <a href={queryData.site.siteMetadata.angel} className={classes.bottomSocialLink}>
                                    <FontAwesomeIcon icon={['fab', 'angellist']} size="lg" fixedWidth />
                                </a>
                            </Grid> */}
                        </Grid>
                    </Grid>
                </Grid>
            </PageSection>
        </Box>
    );
};

PageFooter.defaultProps = {};

PageFooter.propTypes = {};

export default PageFooter;
